import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import score from 'src/helper/score'
import cdn from 'src/helper/cdn'
import Toast from 'src/component/Toast'
import { jumpToUser } from 'src/helper/webviewFun'
import { apiGetLadiesMonthRank, apiGetLadiesRecord, apiLadiesRegisterCount, apiGetApplyState } from 'src/helper/ladies'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
const rewardsRules = [
  {
    gold: '1',
    medal: '3',
    ratio: '5',
    time: '40k',
    sn: '6k'
  },
  {
    gold: '2',
    ratio: '14',
    medal: '10',
    time: '200k',
    sn: '15k'
  },
  {
    gold: '3',
    ratio: '14',
    medal: '10',
    time: '800k',
    sn: '40k'
  }
]
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.store = this.props.store.register('activity/ladies')
    setDocumentTitle('Queen')
  }
  state = {
    userinfo: {},
    count: 0,
    lang: langM.en,
    language: 'en',
    ruleStatus: false,
    recordStatus: false,
    time: 0,
    toastContent: '',
    tab: 1,
    recordres: {},
    record: [],
    rank: [],
    res: {},
    myrank: {},
    lastmyrank: {},
    first: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    two: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    three: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },

    lastrank: [],
    lastres: {},
    lastfirst: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    lasttwo: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    lastthree: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },

    ranklength: 0,
    rankLastlength: 0,

    cd: 0,
    reasonContent: 0,
    currentState: 0,
    micTime: 0,

    timeCd: '',

    enRewardsBoxList: [
      {
        title: 'No.1',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/king.png',
            title: 'VIP5 14D'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen1.png',
            title: 'Head 14D'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen1.png',
            title: 'Car 14D'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal1.png',
            title: 'Medal'
          },
          {
            img: '/img/gold.png',
            title: '200k coins'
          }
        ]
      },
      {
        title: 'No.2',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/duke.png',
            title: 'VIP4 14D'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen2.png',
            title: 'Head 14D'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen2.png',
            title: 'Car 14D'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal2.png',
            title: 'Medal'
          },
          {
            img: '/img/gold.png',
            title: '150k coins'
          }
        ]
      },
      {
        title: 'No.3',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/marquis.png',
            title: 'VIP3 14D'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen3.png',
            title: 'Head 14D'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen3.png',
            title: 'Car 14D'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal3.png',
            title: 'Medal'
          },
          {
            img: '/img/gold.png',
            title: '100k coins'
          }
        ]
      }
    ],
    trRewardsBoxList: [
      {
        title: 'No.1',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/king.png',
            title: 'Vip5 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen1.png',
            title: 'Çerçeve 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen1.png',
            title: 'Araç 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal1.png',
            title: 'Madalya'
          },
          {
            img: '/img/gold.png',
            title: 'Alınanların %10’u'
          }
        ]
      },
      {
        title: 'No.2',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/duke.png',
            title: 'Vip4 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen2.png',
            title: 'Çerçeve 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen2.png',
            title: 'Araç 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal2.png',
            title: 'Madalya'
          },
          {
            img: '/img/gold.png',
            title: 'Alınanların %7’u'
          }
        ]
      },
      {
        title: 'No.3',
        list: [
          {
            img: 'https://img.chatie.live/app/noble/marquis.png',
            title: 'Vip3 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/headwear/queen3.png',
            title: 'Çerçeve 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/mount/queen3.png',
            title: 'Araç 14Gün'
          },
          {
            img: 'https://img.chatie.live/app/medal/images/queen_medal3.png',
            title: 'Madalya'
          },
          {
            img: '/img/gold.png',
            title: 'Alınanların %5’u'
          }
        ]
      }
    ]
  }

  /**
   * @description 初始化语言
   */
  async initLang() {
    let { language } = this.props.location.query
    language = await getlang(language)
    console.log('language', language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
  }

  /**
   * @description 初始化申请信息
   */
  async initApplyState() {
    let res = await apiGetApplyState()
    this.setState({
      sendCd: res && res.res && res.res.countDown,
      reasonContent: res && res.res && res.res.reason,
      currentState: res && res.res && res.res.state,
      micTime: res && res.res && res.res.micTime
    })
    this.countDown2(this.state.sendCd)
  }

  /**
   * @description 初始化个人信息
   */
  async initInfo(uid) {
    let data = await this.store.GetUserInfoWeb(uid)
    this.setState({
      userinfo: data && data.res
    })
  }

  async componentWillMount() {
    // 初始化语言
    this.initLang()
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
    // 初始化申请信息
    this.initApplyState()
  }

  componentDidMount() {
    this.$logEvent('queen_main_screen')
  }

  async RunOnStart(uid) {
    // 初始化个人信息
    this.initInfo(uid)
    // 初始化排行列表
    this.handleGetRank(1)
    if (this.state.language == 'tr') {
      setDocumentTitle('Kraliçe')
    }
  }

  hideRule = async (status) => {
    if (status) {
      this.$logEvent('queen_rule')
    }
    this.setState({
      ruleStatus: status
    })
  }

  hideRecord = async (status) => {
    this.setState({
      recordStatus: status
    })
  }

  countDown = (times) => {
    var timer = null
    let { language } = this.state
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          daystr = day + (language == 'tr' ? 'Gün' : language == 'ar' ? 'يوم' : 'day')
        }
        this.setState({
          time: daystr + hour + ':' + minute + ':' + second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  countDown2 = (times) => {
    let { language } = this.state
    var timer = null
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          daystr = day + (language == 'tr' ? 'Gün' : language == 'ar' ? 'يوم' : 'day')
        }

        this.setState({
          timeCd: daystr + hour + ':' + minute + ':' + second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  async handleGetRank(number) {
    this.setState({ tab: number })
    this.setState({ res: await apiGetLadiesMonthRank(0) })
    this.setState({ lastres: await apiGetLadiesMonthRank(30) })
    this.handleGetThisRank(number)
    this.handleGetLastRank(0)
    this.setState({ recordres: await apiGetLadiesRecord() })
    this.setState({ count: await apiLadiesRegisterCount() })

    let timeC = this.state.res.res.countDown
    if (timeC > 0) {
      this.countDown(timeC)
    }

    this.setState({ record: this.state.recordres.res })
  }

  async handleGetThisRank(number) {
    this.$logEvent('queen_thisMonth_rank')
    this.setState({ tab: number })
    const params = { avatarurl: '', uid: '', nickname: '', val: '' }
    var res = this.state.res

    this.setState({ myrank: res.res.myrank })

    this.setState({ ranklength: res.res.list.length })
    if (res.res.list.length) {
      const [first, two, three, ...rest] = res.res.list
      this.setState({ first })
      this.setState({ two: two || params })
      this.setState({ three: three || params })
      this.setState({ rank: rest || [] })
      const index = res.res.list.findIndex((item) => item.uid === this.state.uid)
      if (index !== -1) {
        this.setState({ number: index + 1 })
        this.setState({ user: res.res[index] })
      }
    } else {
      this.setState({ first: params })
      this.setState({ ttwo: params })
      this.setState({ three: params })
      this.setState({ rank: [] })
    }
  }

  async handleGetLastRank(number) {
    this.$logEvent('queen_lastMonth_rank')
    if (number > 0) {
      this.setState({ tab: number })
    }
    const params = { avatarurl: '', uid: '', nickname: '', val: '' }
    var res = this.state.lastres
    this.setState({ lastmyrank: res.res.myrank })

    this.setState({ rankLastlength: res.res.list.length })
    if (res.res.list.length) {
      const [first, two, three, ...rest] = res.res.list
      this.setState({ lastfirst: first || params })
      this.setState({ lasttwo: two || params })
      this.setState({ lastthree: three || params })
      this.setState({ lastrank: rest || [] })
      const index = res.res.list.findIndex((item) => item.uid === this.state.uid)
      if (index !== -1) {
        this.setState({ number: index + 1 })
        this.setState({ user: res.res[index] })
      }
    } else {
      this.setState({ lastfirst: params })
      this.setState({ lasttwo: params })
      this.setState({ lastthree: params })
      this.setState({ lastrank: [] })
    }
  }

  renderThisMonthRank() {
    return (
      <div
        style={{ display: `${this.state.tab == 1 ? 'block' : 'none'}` }}
        className={`user-rank-content ${this.state.language == 'ar' ? 'arlang' : ''}`}
      >
        <div className="user-rank-content--rank" style={{ display: `${this.state.ranklength ? 'flex' : 'none'}` }}>
          <div className="user-rank-box" onClick={jumpToUser.bind(this, this.state.two.uid)}>
            <img className="avatar" src="/img/activity/ladies/two.png" alt="" />
            <img className="user-avatar" src={cdn(this.state.two.avatarurl)} alt="" />
            <p className="name name1">{this.state.two.nickname}</p>
            <p className="id">{this.state.two.duid}</p>
            <div className="number">{score(this.state.two.val)}</div>
          </div>
          <div onClick={jumpToUser.bind(this, this.state.first.uid)}>
            <img className="avatar av1" src="/img/activity/ladies/one.png" alt="" />
            <img className="user-avatar av1" src={cdn(this.state.first.avatarurl)} alt="" />
            <p className="name">{this.state.first.nickname}</p>
            <p className="id">{this.state.first.duid}</p>
            <div className="number">{score(this.state.first.val)}</div>
          </div>
          <div className="user-rank-box" onClick={jumpToUser.bind(this, this.state.three.uid)}>
            <img className="avatar" src="/img/activity/ladies/three.png" alt="" />
            <img className="user-avatar" src={cdn(this.state.three.avatarurl)} alt="" />
            <p className="name name1">{this.state.three.nickname}</p>
            <p className="id">{this.state.three.duid}</p>
            <div className="number">{score(this.state.three.val)}</div>
          </div>
        </div>
        <div className="user-rank-content--list">
          {this.state.rank.map((item, index) => {
            return (
              <div key={item.uid} className="list-item" onClick={jumpToUser.bind(this, item.uid)}>
                <div className="item-rank">
                  <span>{index + 4}</span>
                </div>
                <img className="item-avatar" src={cdn(item.avatarurl)} />
                <div className="item-info">
                  <p>{item.nickname}</p>
                  <p>ID:{item.duid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                </div>
              </div>
            )
          })}
          {this.state.myrank && this.state.myrank.uid && this.state.userinfo.gender == 2 && (
            <div
              key={this.state.myrank.uid}
              className="list-item myrank"
              onClick={jumpToUser.bind(this, this.state.myrank.uid)}
            >
              <div className="item-rank">
                <span>{this.state.myrank.rank}</span>
              </div>
              <img className="item-avatar" src={cdn(this.state.myrank.avatarurl)} />
              <div className="item-info">
                <p>{this.state.myrank.nickname}</p>
                <p>ID:{this.state.myrank.duid}</p>
              </div>
              <div className="item-number">
                <span>{score(this.state.myrank.val)}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderLastMonthRank() {
    return (
      <div
        style={{ display: `${this.state.tab == 2 ? 'block' : 'none'}` }}
        className={`user-rank-content ${this.state.language == 'ar' ? 'arlang' : ''}`}
      >
        <div className="user-rank-content--rank" style={{ display: `${this.state.rankLastlength ? 'flex' : 'none'}` }}>
          <div className="user-rank-box" onClick={jumpToUser.bind(this, this.state.lasttwo.uid)}>
            <img className="avatar" src="/img/activity/ladies/two.png" alt="" />
            <img className="user-avatar" src={cdn(this.state.lasttwo.avatarurl)} alt="" />
            <p className="name name1">{this.state.lasttwo.nickname}</p>
            <p className="id">{this.state.lasttwo.duid}</p>
            <div className="number">{score(this.state.lasttwo.val)}</div>
          </div>
          <div onClick={jumpToUser.bind(this, this.state.lastfirst.uid)}>
            <img className="avatar av1" src="/img/activity/ladies/one.png" alt="" />
            <img className="user-avatar av1" src={cdn(this.state.lastfirst.avatarurl)} alt="" />
            <p className="name">{this.state.lastfirst.nickname}</p>
            <p className="id">{this.state.lastfirst.duid}</p>
            <div className="number">{score(this.state.lastfirst.val)}</div>
          </div>
          <div className="user-rank-box" onClick={jumpToUser.bind(this, this.state.lastthree.uid)}>
            <img className="avatar" src="/img/activity/ladies/three.png" alt="" />
            <img className="user-avatar" src={cdn(this.state.lastthree.avatarurl)} alt="" />
            <p className="name name1">{this.state.lastthree.nickname}</p>
            <p className="id">{this.state.lastthree.duid}</p>
            <div className="number">{score(this.state.lastthree.val)}</div>
          </div>
        </div>
        <div className="user-rank-content--list">
          {this.state.lastrank.map((item, index) => {
            return (
              <div key={item.uid} className="list-item" onClick={jumpToUser.bind(this, item.uid)}>
                <div className="item-rank">
                  <span>{index + 4}</span>
                </div>
                <img className="item-avatar" src={cdn(item.avatarurl)} />
                <div className="item-info">
                  <p>{item.nickname}</p>
                  <p>ID:{item.duid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                </div>
              </div>
            )
          })}
          {this.state.lastmyrank != undefined && this.state.userinfo.gender == 2 && (
            <div
              key={this.state.lastmyrank.uid}
              className="list-item myrank"
              onClick={jumpToUser.bind(this, this.state.lastmyrank.uid)}
            >
              <div className="item-rank">
                <span>{this.state.lastmyrank.rank}</span>
              </div>
              <img className="item-avatar" src={cdn(this.state.lastmyrank.avatarurl)} />
              <div className="item-info">
                <p>{this.state.lastmyrank.nickname}</p>
                <p>ID:{this.state.lastmyrank.duid}</p>
              </div>
              <div className="item-number">
                <span>{score(this.state.lastmyrank.val)}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  goToRegister = () => {
    // 不做操作
    if (this.state.currentState == null || this.state.currentState == 2) {
      let { uid, accesstoken } = localstorage.get('userInfo')
      history.push(`/activity/ladiesregister?uid=${uid}&accesstoken=${accesstoken}&language=${this.state.language}`)
      window.scroll(0, 0)
    } else {
      return
    }
  }

  render() {
    let { language, lang } = this.state
    return (
      <div className={`ladies-page ${language == 'ar' && 'arlang'}`}>
        <div className="head-box">
          <div
            className="star"
            onClick={() => {
              console.log(logEvent, 'logEventlogEventlogEventlogEvent')
            }}
          >
            <img src="/img/activity/ramadan/star3.gif" alt="" />
          </div>
          <div className="countdown-box">
            {this.state.lang.timeR}: {this.state.time}
          </div>
        </div>
        <div className="sketch">
          <div className="head-rule-box">
            <div className="head-rule">
              {/* {this.state.lang.live1}
              <br />
              {this.state.lang.live2}
              <br /> */}

              <p>{this.state.currentState != 1 && this.state.lang.live2}</p>
              {this.state.currentState == 2 && (
                <p>
                  {this.state.lang.refuseReason}：{this.state.reasonContent || ''}
                </p>
              )}
              {this.state.currentState == 1 && (
                <p>
                  {this.state.lang.currentMicTime}：{this.state.micTime.toFixed(2)}
                </p>
              )}
              {this.state.currentState == 1 && <p>{this.state.lang.meetConditions(' ' + this.state.timeCd + ' ')}</p>}
            </div>
          </div>
          <div className="rules-apply">
            <span>{`${lang.apply}  ${language == 'tr' ? '' : lang.ruleText}`}</span>
            <div
              className={`content ${language == 'ar' && 'arlang'}`}
              dangerouslySetInnerHTML={{ __html: lang.applyRule }}
            ></div>
          </div>
          <div className="rwb-table">
            <table>
              <thead>
                <tr>
                  <td>{lang.trOne}</td>
                  <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trTwo}</td>
                  <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trThree}</td>
                  <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trFour}</td>
                  <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trFive}</td>
                </tr>
              </thead>

              {rewardsRules.map((item, index) => {
                return (
                  <tbody key={index}>
                    <tr>
                      <td>{item.gold}</td>
                      <td>{item.medal}</td>
                      <td>{item.ratio}</td>
                      <td>{item.time}</td>
                      <td>{item.sn}</td>
                    </tr>
                  </tbody>
                )
              })}
            </table>
          </div>
          <div className="monthly">{this.state.lang.monthlyLeaderboard}</div>
        </div>

        <div className="content-box">
          <div className="tab">
            <div onClick={this.handleGetThisRank.bind(this, 1)} className={this.state.tab === 1 ? 'act1' : ''}>
              {this.state.lang.thismonth}
            </div>
            <div onClick={this.handleGetLastRank.bind(this, 2)} className={this.state.tab === 2 ? 'act2' : ''}>
              {this.state.lang.lastmonth}
            </div>
            <div
              onClick={() => {
                this.$logEvent('queen_reward')
                this.setState({ tab: 3 })
              }}
              className={this.state.tab === 3 ? 'act3' : ''}
            >
              {this.state.lang.rewards}
            </div>
          </div>

          {this.renderThisMonthRank()}
          {this.renderLastMonthRank()}

          <div className="rewards" style={{ display: `${this.state.tab == 3 ? 'block' : 'none'}` }}>
            {this.state.language == 'tr' &&
              this.state.trRewardsBoxList.map((i, index) => {
                return (
                  <div className="rewards-box">
                    <div className="rewards-box-no">
                      <span>{i.title}</span>
                    </div>
                    <div className="reward-div">
                      {i.list.map((item, idx) => {
                        return (
                          <div className="reward-div1" key={idx}>
                            <div>
                              <img src={item.img} />
                            </div>
                            <p>{item.title}</p>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            {this.state.language != 'tr' &&
              this.state.enRewardsBoxList.map((i, index) => {
                return (
                  <div className="rewards-box">
                    <div className="rewards-box-no">
                      <span>{i.title}</span>
                    </div>
                    <div className="reward-div">
                      {i.list.map((item, idx) => {
                        return (
                          <div className="reward-div1" key={idx}>
                            <div>
                              <img src={item.img} />
                            </div>
                            <p>{item.title}</p>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
          </div>

          {/* <p className="copyright"></p> */}
          {this.state.language != 'tr' && (
            <div className="service" onClick={jumpToUser.bind(this, 977239)}>
              {lang.copyright}
              <br />
              {lang.service}
            </div>
          )}
          {this.state.language == 'tr' && (
            <div className="service" onClick={jumpToUser.bind(this, 113742)}>
              {lang.copyright}
              <br />
              {lang.service}
            </div>
          )}
        </div>

        <Toast
          language={language}
          lang={this.state.lang}
          ref="toast"
          id="toast"
          toastContent={this.state.toastContent}
        />

        {/* 规则页面 */}
        <div className="rules" onClick={this.hideRule.bind(this, true)}>
          {this.state.lang.ruleText}
        </div>

        {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}
        {this.state.ruleStatus && (
          <div className={`popRule animationBeBigCenter`} onClick={this.hideRule.bind(this, false)}>
            <div className="hg">
              <img src="/img/activity/ladies/hg.png" alt="" />
            </div>
            <span> {this.state.lang.ruleText}</span>
            <div
              className={`content ${language == 'ar' && 'arlang'}`}
              dangerouslySetInnerHTML={{ __html: lang.rule }}
            ></div>
            {/* <p>Yayya has the final right of this activity .</p> */}
          </div>
        )}

        {/* record页面 */}
        {this.state.userinfo.gender == 2 && (
          <div>
            {/* <div className="record" onClick={this.hideRecord.bind(this, true)}> */}
            {/* {this.state.lang.ruleText} */}
            {/* {this.state.lang.record} */}
            {/* </div> */}

            {this.state.recordStatus && <div className="loading" onClick={this.hideRecord.bind(this, false)}></div>}
            {this.state.recordStatus && (
              <div className={`popRule popRecord animationBeBigCenter`} onClick={this.hideRecord.bind(this, false)}>
                <span>{this.state.lang.record}</span>
                <div>
                  {this.state.record.map((item, index) => {
                    return (
                      <div className="record-list">
                        <div>
                          {' '}
                          <span
                            className={`${item.rank == '' && ''} ${
                              (item.rank == '1' || item.rank == '2' || item.rank == '3') && ''
                            }`}
                          >
                            {item.rank}
                          </span>
                        </div>
                        <div>
                          <div
                            className={`avatarurl-box ${item.rank == '' && ''} ${
                              (item.rank == '1' || item.rank == '2' || item.rank == '3') && ''
                            }`}
                          >
                            <img src={item.avatarUrl}></img>
                          </div>
                        </div>
                        <div>
                          <div className="date-month">{item.statdate}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        {/* 女孩注册显示按钮 */}
        {this.state.userinfo.gender == 2 && (
          <div
            className={`bottomBtn ${(this.state.currentState == 0 || this.state.currentState == 1) && 'bottomBtng'}`}
            onClick={() => {
              this.goToRegister()
            }}
          >
            {/* {this.state.lang.girlsupport} */}

            {/* 申请中 */}
            {/* 通过 */}
            {/* 拒绝 */}
            {this.state.currentState == 0 && this.state.lang.waitExamine}
            {this.state.currentState == 1 && this.state.lang.hadPass}
            {(this.state.currentState == 2 || this.state.currentState == null) && this.state.lang.girlsupport}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/ladies/index.js